<template>
  <svg
    id="Mobile_icon"
    data-name="Mobile icon"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <rect
      id="Rectangle_1882"
      data-name="Rectangle 1882"
      width="16"
      height="16"
      fill="none"
    />
    <rect
      id="Rectangle_1881"
      data-name="Rectangle 1881"
      width="9"
      height="15"
      rx="2"
      transform="translate(3.5 0.5)"
      fill="none"
      stroke="#2d323c"
      stroke-width="1"
    />
    <circle
      id="Ellipse_325"
      data-name="Ellipse 325"
      cx="0.75"
      cy="0.75"
      r="0.75"
      transform="translate(7.25 1.75)"
      fill="#2d323c"
    />
    <path
      id="Path_2398"
      data-name="Path 2398"
      d="M2462.064-5259.767h3"
      transform="translate(-2455.564 5273.267)"
      fill="none"
      stroke="#2d323c"
      stroke-linecap="round"
      stroke-width="1"
    />
  </svg>
</template>

<script>
export default {
  name: 'Mobile',
}
</script>

<style lang="scss" scoped></style>
